export default "__VITE_ASSET__D9Tq2hgZ__"